import { createAsyncThunk } from '@reduxjs/toolkit'
import { FetchAssignedTeamMemberParams } from './types'
import axios from '../../../../config/axios'

export const fetchAssignedTeamMembers = createAsyncThunk(
  'assignedTeamMemberPerTask/fetchAssignedTeamMembers',
  async (params: FetchAssignedTeamMemberParams, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/report/task/${params.taskId}/assignedTeamMember`)
      return response.data
    } catch (error) {
      return rejectWithValue('Failed to fetch invited team members')
    }
  },
)
